module.exports = {
    ENV_URL_API: process.env.REACT_APP_ENV_URL_API || 'http://localhost:8001',
    ENV_URL_WS: process.env.REACT_APP_ENV_URL_WS || 'ws://localhost:8001'
}